import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, retry } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TaxDocSummary } from './models/tax-doc-summary';
import { TaxDocDetail } from './models/tax-doc-detail';
import { EmailSuccessResponse } from './models/email-success-response';

@Injectable({
    providedIn: 'root'
})
export class TaxDocClient {

    private readonly _taxDocClientUrl: string;
    private readonly useCredentials: boolean = false;

    constructor(
        private _http: HttpClient) {
        this._taxDocClientUrl = environment.services.taxDocNotifierApi + '/TaxDoc/';
        if (environment.services.taxDocNotifierApi.indexOf('localhost:44338') >= 0)
            this.useCredentials = true;
    }

    getTaxDocSummaries(): Observable<TaxDocSummary[]> {
        const url = this._taxDocClientUrl + 'GetTaxDocSummaries';
        return this._http.get<TaxDocSummary[]>(url, { withCredentials: this.useCredentials })
                .pipe(retry(1));
    }

    getTaxDocSummary(loadId: number): Observable<TaxDocSummary> {
        const url = this._taxDocClientUrl + `GetTaxDocSummary?loadId=${loadId}`;
        return this._http.get<TaxDocSummary>(url, { withCredentials: this.useCredentials })
                .pipe(retry(1));
    }

    getTaxDocDetails(loadId: number, page: number, pageSize: number): Observable<TaxDocDetail[]> {
        const url = this._taxDocClientUrl + `GetTaxDocDetails?loadId=${loadId}&page=${page}&pageSize=${pageSize}`;
        return this._http.get<TaxDocDetail[]>(url, { withCredentials: this.useCredentials })
                .pipe(retry(1));
    }

    getTaxDocDetailsBySearchTerm(loadId: number, accountNumber: string, sent: boolean): Observable<TaxDocDetail[]> {
        const url = this._taxDocClientUrl + `GetTaxDocDetailsBySearchTerm?loadId=${loadId}&accountNumber=${accountNumber}&isSent=${sent}`;
        return this._http.get<TaxDocDetail[]>(url, { withCredentials: this.useCredentials });
    }

    getPageCountForLoad(loadId: number, pageSize: number): Observable<number> {
        const url = this._taxDocClientUrl + `GetPageCountForLoad?loadId=${loadId}&pageSize=${pageSize}`;
        return this._http.get<number>(url, { withCredentials: this.useCredentials })
                .pipe(retry(1));
    }
    
    approveTaxLoad(loadId: number): Observable<boolean> {
        const url = this._taxDocClientUrl + `ApproveTaxLoad?loadId=${loadId}`;
        return this._http.post<boolean>(url, null,{ withCredentials: this.useCredentials });
    }
}

@Injectable({
    providedIn: 'root'
})
export class EmailClient {

    private readonly _emailClientUrl: string;
    private readonly useCredentials: boolean = false;

    constructor(
        private _http: HttpClient) {
        this._emailClientUrl = environment.services.taxDocNotifierApi + '/Email/';
        if (environment.services.taxDocNotifierApi.indexOf('localhost:44338') >= 0)
            this.useCredentials = true;
    }

    sendTestEmail(taxDocDetail: TaxDocDetail, docType: string, taxYear: string, loadId: number): Observable<EmailSuccessResponse> {
        const url = this._emailClientUrl + `SendTestEmail?docType=${docType}&taxYear=${taxYear}&loadId=${loadId}`;
        return this._http.post<EmailSuccessResponse>(url, taxDocDetail, { withCredentials: this.useCredentials });
    }
}